module.exports = __webpack_public_path__ + "img/unisi_logo_trasparente.ddb1ca79.png";